import {useEffect, useState} from 'react';

const OFFLINE_DEBOUNCE_MS = 600;

function recheckOnlineStatus() {
  window.dispatchEvent(new Event(navigator.onLine ? 'online' : 'offline'));
}

function useIsOffline() {
  const [isOffline, setIsOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined;

    const handleOnline = () => {
      clearTimeout(timeout);
      setIsOffline(false);
    };
    const handleOffline = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setIsOffline(true), OFFLINE_DEBOUNCE_MS);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOffline;
}

export {useIsOffline, recheckOnlineStatus};
